import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

export default {
    path: '/accounting',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
    component: () => import('../components/pages/accounting/AccountingGeneral.vue'),
    children: [
        {
            path: '', name: "AccountingMain",
            redirect: '/accounting/current/summary',
        },
        // {
        //     path: '', name: "AccountingMain",
        //     meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
        //     component: () => import('../components/pages/accounting/AccountingRouter.vue'),
        // },
        {
            path: ':id',
            meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
            component: () => import('../components/pages/accounting/AccountingMonthGeneral.vue'),
            children: [
                // { path: '', redirect: '/:id/summary' },
                { path: '', redirect: to => ({ name: 'AccountingMonthSummary', params: { id: to.params.id } }) },
                {
                    path: 'summary', name: "AccountingMonthSummary",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMonthSummary.vue')
                },
                {
                    path: 'salaries', name: "AccountingMonthSalaries",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMonthSalaries.vue')
                },
                {
                    path: 'materials', name: "AccountingMonthMaterials",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMonthMaterials.vue')
                },
                {
                    path: 'other_expense', name: "AccountingMonthOtherExpense",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMonthOtherExpense.vue')
                },
                {
                    path: 'other_income', name: "AccountingMonthOtherIncome",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMonthOtherIncome.vue')
                },
                {
                    path: 'categories', name: "AccountingMonthOtherIncomeCategory",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMonthOtherIncomeCategory.vue')
                },
                {
                    path: 'months', name: "AccountingMonths",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['accounting'] },
                    component: () => import('../components/pages/accounting/AccountingMain.vue'),
                },
            ]
        },
    ]
}
